import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { AppLayout } from '@/app/shell/AppLayout'
import { ModuleEntry } from '@/app/modules/ModuleEntry'
import { LoginPage } from '@/features/auth/LoginPage'
import { ResetPasswordPage } from '@/features/auth/ResetPasswordPage'
import { SettingsPage } from '@/features/settings/SettingsPage'
import { WorkspacePage } from '@/features/workspace/WorkspacePage'
import { ProtectedRoute } from '@/shared/components/ProtectedRoute'
import { NotFoundPage } from '@/shared/components/NotFoundPage'
import { RouteErrorBoundary } from '@/shared/components/RouteErrorBoundary'

const contentError = <RouteErrorBoundary fit="content" />
const pageError = <RouteErrorBoundary fit="page" />

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: pageError },
  { path: '/reset-password', element: <ResetPasswordPage />, errorElement: pageError },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    errorElement: pageError,
    children: [
      { index: true, element: <WorkspacePage />, errorElement: contentError },
      { path: 'settings', element: <SettingsPage />, errorElement: contentError },
      { path: 'm/:slug', element: <ModuleEntry />, errorElement: contentError },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])

export function AppRouter() {
  return <RouterProvider router={router} />
}
